export const ApprovalAppStatus = Object.freeze({ "PENDING": 0, "APPROVED": 1, "REJECTED": 2, "ALL": 3})


// WEBPACK FOOTER //
// ./src/components/ApproveDashboard/models/approvalAppStatus.enum.js